import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaBars, FaTimes } from "react-icons/fa";
import "../../styles/components-styles/header-styles/LandingLayoutHeader.css";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

function LandingLayoutHeader() {
  const navigate = useNavigate();
  // Simulated access token state
  const [hasAccessToken, setHasAccessToken] = useState(false);
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // Account dropdown options
  const accountOptions = ["Profile", "Settings", "Billing", "Help"];

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowAccountDropdown(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        !event.target.classList.contains("mobile-menu-toggle")
      ) {
        setIsMobileMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    // Clear session storage
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("token");
    setHasAccessToken(false);
    navigate("/");
  };

  return (
    <header className="header-container">
      {/* Left Section - Logo & Text */}
      <div className="header-left">
        <div className="logo-container">
          <img src="qbank_logo.png" alt="Qbank360 Logo" className="logo" />
          <span className="logo-text">
            <Link to="/landinghomepage">Qbank360</Link>
          </span>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Desktop Navigation */}
        <nav className="nav-links desktop-nav">
          {!hasAccessToken && (
            <>
              <span className="nav-item">
                <Link to="/signup">Sign Up</Link>
              </span>
              <span className="nav-item">
                <Link to="/contactpage">Contact Us</Link>
              </span>
              <span className="nav-item">
                <Link to="/workwithuspage">Work With Us</Link>
              </span>
            </>
          )}
        </nav>
      </div>

      {/* Right Section for Desktop */}
      <div className="header-right desktop-nav">
        {!hasAccessToken ? (
          <button className="login-button">
            <Link to="/login">Login</Link>
          </button>
        ) : (
          <>
            <span className="nav-item">Install App</span>
            {/* Account Dropdown */}
            <div
              className="dropdown-container"
              ref={dropdownRef}
              onClick={() => setShowAccountDropdown(!showAccountDropdown)}
            >
              <span className="nav-item">Account</span>
              <FaChevronDown className="dropdown-icon" />
              {showAccountDropdown && (
                <ul className="dropdown-menu">
                  {accountOptions.map((option, index) => (
                    <li
                      key={index}
                      className="dropdown-item"
                      onClick={() => navigate(`/${option.toLowerCase()}`)}
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <span className="nav-item logout-btn" onClick={handleLogout}>
              Log Out
            </span>
          </>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu" ref={mobileMenuRef}>
          {!hasAccessToken ? (
            <>
              <Link
                to="/signup"
                className="mobile-nav-item"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Sign Up
              </Link>
              <Link
                to="/contactpage"
                className="mobile-nav-item"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact Us
              </Link>
              <Link
                to="/workwithuspage"
                className="mobile-nav-item"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Work With Us
              </Link>
              <Link
                to="/login"
                className="mobile-nav-item mobile-login-btn"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Login
              </Link>
            </>
          ) : (
            <>
              <span className="mobile-nav-item">Install App</span>
              {/* Mobile Account Options */}
              <div className="mobile-account-section">
                <span className="mobile-nav-item mobile-section-title">
                  Account
                </span>
                {accountOptions.map((option, index) => (
                  <Link
                    key={index}
                    to={`/${option.toLowerCase()}`}
                    className="mobile-nav-item mobile-account-option"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {option}
                  </Link>
                ))}
              </div>
              <span
                className="mobile-nav-item mobile-logout-btn"
                onClick={() => {
                  handleLogout();
                  setIsMobileMenuOpen(false);
                }}
              >
                Log Out
              </span>
            </>
          )}
        </div>
      )}
    </header>
  );
}

export default LandingLayoutHeader;
